    angular.module('lead-bant')
        .component('leadBantQuestionsAnswers', {
            bindings: {
                leadId: '<'
            },
            templateUrl: 'app/lead/bant/questions-answers.html',
            controller: function ($scope, $state, $stateParams, LeadBantService, LeadBantQuestions, modals) {
                this.LeadBantService = LeadBantService;

                this.$onInit = () => {
                    LeadBantQuestions.answers({id: this.leadId}).$promise.then(bant => this.item = bant)
                }

                this.save = () => {
                    let promise
                    if(this.item.id == null) {
                        promise = LeadBantQuestions.saveAnswers({id: this.leadId}, this.item).$promise
                    }
                    else {
                        promise = LeadBantQuestions.updateAnswers({id: this.leadId}, this.item).$promise
                    }
                    promise.then(() => this.$onInit())
                }

                this.delete = () => {
                    return modals.confirmDelete("wszystkie wypełnione odpowiedzi", () => LeadBantQuestions.deleteAnswers({id: this.leadId}).$promise).then(() => this.$onInit())

                }
            }
        })
